"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Typography_1 = __importDefault(require("@cvent/carina/components/Typography/Typography/Typography"));
var BlocksTypography_1 = require("./BlocksTypography");
function Typography(props) {
    var styledAs = props.styledAs, cssProp = props.css;
    var css = cssProp || {};
    if (styledAs && BlocksTypography_1.baseElementHeadingsKeys.includes(styledAs)) {
        css = __assign({ color: "var(--blocks-".concat(styledAs, "-color)"), fontFamily: "var(--blocks-".concat(styledAs, "-font-family)"), fontSize: "var(--blocks-".concat(styledAs, "-font-size)"), fontWeight: "var(--blocks-".concat(styledAs, "-font-weight)"), lineHeight: "var(--blocks-".concat(styledAs, "-line-height)") }, css);
    }
    return (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ css: css }, props));
}
exports.default = Typography;
//# sourceMappingURL=Typography.js.map